__turbopack_context__.v({
  "calculator": "FlatCalculator-module-scss-module__3H5A0G__calculator",
  "calculator__title": "FlatCalculator-module-scss-module__3H5A0G__calculator__title",
});
